/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Label editor remove modal component
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.0.0
 */

import { memo } from 'react';

import {
    ExportMessageContainerStyled,
    ExportMessageDescriptionStyled,
    ExportMessageTitleStyled,
    FooterContainerStyled,
} from '../../../../../../modules/exports/components/styled/ExportMessageStyled';
import { ILabelEditorTranslation } from '../../../../../../modules/internationalization/types/corporate';
import { stringFormatParams } from '../../../../../../utils/stringFormat';
import { Button, LinkBlock } from '../../../../../common';

export interface ILabelEditorRemoveModalProps {
    handleClose: () => void;
    handleSubmit?: () => void;
    name: string;
    translation: ILabelEditorTranslation;
}

const LabelEditorRemoveModal = (props: ILabelEditorRemoveModalProps) => {

    const { handleClose, handleSubmit, translation } = props;

    return (
        <ExportMessageContainerStyled
            data-component={'modal-popup'}
            data-name={'label-editor-remove-modal'}
        >
            <ExportMessageTitleStyled>
                {translation.removeModal.title}
            </ExportMessageTitleStyled>
            <ExportMessageDescriptionStyled>
                {stringFormatParams(translation.removeModal.text, {
                    name: props.name,
                })}
            </ExportMessageDescriptionStyled>
            <FooterContainerStyled>
                <Button
                    className="export-message__apply-btn"
                    disabled={false}
                    kind="medium"
                    onClick={handleSubmit}>
                    {translation.removeModal.buttonOk}
                </Button>
                <LinkBlock
                    className="export-message__cancel-btn"
                    onClick={handleClose}
                >
                    {translation.removeModal.buttonCancel}
                </LinkBlock>
            </FooterContainerStyled>
        </ExportMessageContainerStyled>
    );
};

export default memo(LabelEditorRemoveModal);
